import { createActionCreators} from "../utils/actionCreators";

export const {
    request: getContractRequest,
    success: getContractSuccess,
    failure: getContractFailure
} = createActionCreators('GET_CONTRACT');

export const {
    request: getContractsRequest,
    success: getContractsSuccess,
    failure: getContractsFailure
} = createActionCreators('GET_CONTRACTS');

export const {
    request: addContractRequest,
    success: addContractSuccess,
    failure: addContractFailure
} = createActionCreators('ADD_CONTRACT');

export const {
    request: updateContractRequest,
    success: updateContractSuccess,
    failure: updateContractFailure
} = createActionCreators('UPDATE_CONTRACT');

export const {
    request: confirmContractRequest,
    success: confirmContractSuccess,
    failure: confirmContractFailure
} = createActionCreators('CONFIRM_CONTRACT');

export const {
    request: deleteContractRequest,
    success: deleteContractSuccess,
    failure: deleteContractFailure
} = createActionCreators('DELETE_CONTRACT');

export const {
    request: copyContractRequest,
    success: copyContractSuccess,
    failure: copyContractFailure
} = createActionCreators('COPY_CONTRACT');

export const {
    request: changeContractRequest,
    success: changeContractSuccess,
    failure: changeContractFailure
} = createActionCreators('CHANGE_CONTRACT');

export const {
    request: acceptChangeContractRequest,
    success: acceptChangeContractSuccess,
    failure: acceptChangeContractFailure
} = createActionCreators('ACCEPT_CHANGE_CONTRACT');

export const {
    request: stopContractRequest,
    success: stopContractSuccess,
    failure: stopContractFailure
} = createActionCreators('STOP_CONTRACT');

export const {
    request: setSchoolCommentRequest,
    success: setSchoolCommentSuccess,
    failure: setSchoolCommentFailure
} = createActionCreators('SET_SCHOOL_COMMENT');

export const {
    request: setSchoolYearRequest,
    success: setSchoolYearSuccess,
    failure: setSchoolYearFailure
} = createActionCreators('SET_SCHOOL_YEAR');